export const StatusCessaoEnum = {
  REALIZADO: 1,
  EM_ANALISE: 2,
  PENDENCIAS: 3,
  INDEFERIDO: 4,
  DEFERIDO: 5,
  DEFERIDO_TRANSFERIDO: 6,
  DEFERIDO_DEVOLVIDO: 7,
  ACEITE_CONFIRMADO: 8
};
